import WorkerApiService from "../../workerApiServices";

class TipoDeDescontoService extends WorkerApiService {

    constructor() {
        super('/api/tipoDeDesconto')
    }

    search(){
        return this.get("/search")
    }

    save(object){
        return this.post("/save", object)
    }

    edit(object){
        return this.put("/edit", object)
    }



}

export default TipoDeDescontoService